import { useState } from "react";
import {
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
  Button,
  alpha,
  useTheme,
  CircularProgress,
} from "@mui/material";
import { useTranslation } from "react-i18next";

const DeleteConfirmDialog = ({ open, onClose, onConfirm, itemName, itemType }) => {
  const { t } = useTranslation();
  const theme = useTheme();
  const [loading, setLoading] = useState(false);

  const handleConfirm = async () => {
    setLoading(true);
    try {
      await onConfirm();
    } finally {
      setLoading(false);
    }
  };

  return (
    <Dialog
      open={open}
      onClose={onClose}
      maxWidth="xs"
      fullWidth
      PaperProps={{
        sx: {
          borderRadius: "16px",
          border: `1px solid ${theme.palette.divider}`,
          boxShadow:
            theme.palette.mode === "dark"
              ? "0 4px 20px rgba(0,0,0,0.5)"
              : "0 4px 20px rgba(0,0,0,0.1)",
        },
      }}
    >
      <DialogTitle
        sx={{
          pb: 1,
          pt: 3,
          px: 3,
          fontWeight: 600,
          fontSize: "1.25rem",
        }}
      >
        {t("mkt_delete_title", { type: itemType || t("mkt_item") })}
      </DialogTitle>
      <DialogContent sx={{ px: 3, pt: 2 }}>
        <DialogContentText sx={{ color: theme.palette.text.secondary }}>
          {t("mkt_delete_confirm", { name: itemName || "" })}
        </DialogContentText>
      </DialogContent>
      <DialogActions sx={{ px: 3, pb: 3, pt: 2 }}>
        <Button
          onClick={onClose}
          disabled={loading}
          sx={{
            color: theme.palette.text.secondary,
            textTransform: "none",
            fontWeight: 500,
          }}
        >
          {t("common_cancel", "Cancel")}
        </Button>
        <Button
          onClick={handleConfirm}
          variant="contained"
          disableElevation
          disabled={loading}
          startIcon={loading ? <CircularProgress size={16} color="inherit" /> : null}
          sx={{
            bgcolor: theme.palette.error.main,
            color: "white",
            textTransform: "none",
            fontWeight: 600,
            px: 3,
            py: 1,
            borderRadius: "8px",
            "&:hover": {
              bgcolor: alpha(theme.palette.error.main, 0.85),
            },
            "&.Mui-disabled": {
              bgcolor: alpha(theme.palette.error.main, 0.6),
              color: "white",
            },
          }}
        >
          {loading ? t("mkt_deleting", "Deleting...") : t("common_delete", "Delete")}
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default DeleteConfirmDialog;
